import { ModalTopSection } from "../../../components/DetailsModal/ModalTopSection";
import {
  DataLoadingView,
  ErrorOccuredView,
  ModalContainer,
  SectionSubheader,
} from "../../../components";
import { ModalSectionTitle } from "../../../components";
import { LeftRightFlexedContainer } from "../../../components";
import { CurrencyDisplay } from "../../../components";
import { Badge } from "../../../components";
import { IProductDetailsModalViewProps } from "./ProductDetailsModal";
import {
  getProductStatusIndicator,
  truncateStringWithEllipsis,
} from "../../../utils";

import imagePlaceholder from "../../../assets/icons/img-placeholder.svg";

export const View = (props: IProductDetailsModalViewProps) => {
  const statusIndicator = props.modalData
    ? getProductStatusIndicator(props.modalData)
    : null;

  return (
    <div className="product-details-container">
      <ModalContainer
        isModalOpen={props.isModalOpen}
        closeModal={props.closeModal}
        className="product-modal-container"
        modalHeader={
          !props.modalData ? (
            <SectionSubheader title="PRODUCT DETAILS" />
          ) : (
            <ModalTopSection
              header="PRODUCT DETAILS"
              subHeader={
                <div className="sub-header flex-container align-items--center justify-content--start">
                  <strong className="product-name--display mr-5">
                    {truncateStringWithEllipsis(
                      props.modalData.product_name,
                      50
                    )}
                  </strong>

                  {/* <Badge
                    text={statusIndicator!.statusText}
                    statusColor={statusIndicator!.statusType}
                  /> */}
                </div>
              }
              copyText="Product ID"
              copyContent={props.modalData.id}
              closeModal={props.closeModal}
            />
          )
        }
      >
        {!props.modalData ? (
          <>
            {props.isLoading ? (
              <DataLoadingView message={"Loading product details"} />
            ) : (
              // props.isError || !props.modalData ?
              <ErrorOccuredView
                message={
                  "An error occured while loading product details. Please retry..."
                }
              />
            )}
          </>
        ) : (
          <>
            <img
              src={props.modalData.product_icon || imagePlaceholder}
              alt="product icon"
              className="swapp-product-icon product-details--product-icon"
            />

            <div>
              <ModalSectionTitle key_id="Details" value={null} />

              <LeftRightFlexedContainer
                key_id="Product Name"
                value={
                  <div className="product-name--display align-self--center">
                    {props.modalData.product_name}
                  </div>
                }
              />

              <LeftRightFlexedContainer
                key_id="Status"
                value={
                  <Badge
                    text={statusIndicator!.statusText}
                    statusColor={statusIndicator!.statusType}
                  />
                }
              />
              <LeftRightFlexedContainer
                key_id="Description"
                value={props.modalData.product_description || "..."}
              />
              {!props.modalData.payout_tag ? null : (
                <LeftRightFlexedContainer
                  key_id="Payout Bank Acc."
                  value={props.modalData.payout_tag}
                />
              )}
            </div>

            <div>
              <ModalSectionTitle key_id="Pricing" value={null} />

              <LeftRightFlexedContainer
                key_id="Currency"
                value={props.modalData.currency}
              />
              <LeftRightFlexedContainer
                key_id="Price"
                value={
                  <>
                    <CurrencyDisplay
                      currencyOrSymbol={props.modalData.currency}
                      amount={props.modalData.price}
                      amountFontSize={16}
                      symbolFontSize={12}
                    />{" "}
                  </>
                }
              />
            </div>

            {/* <div className="flex-container justify-content--end align-items--end btn-container">
              <button className="done--btn" onClick={props.closeModal}>
                Done
              </button>
            </div> */}
          </>
        )}
      </ModalContainer>
    </div>
  );
};
